import React from 'react';
import { Control, useController } from 'react-hook-form';
import { ICategoryForm } from '../types';
import { useFiltersData } from '../../ProductNew/hooks/useFiltersData';
import GridRow from '../../../ui/GridRow';
import GridCol from '../../../ui/GridCol';
import ToggleButton from '../../../ui/ToggleButton/ToggleButton';
import i18n from '../../../utils/i18n';
import { IconEnum } from '../../../ui/Icon';
import Details from '../../../ui/Details/details';

interface ICategoryFilters {
    control: Control<ICategoryForm>;
}

const CategoryFilters = ({ control }: ICategoryFilters) => {
    const filtersData = useFiltersData();
    const {
        field: { value, onChange },
    } = useController({
        control,
        name: 'filtersGroup',
    });

    const handleSelect = (state: boolean, id: number) => {
        const duplicatedSet = new Set(value);
        if (state) {
            duplicatedSet.add(id);
        } else {
            if (duplicatedSet?.has(id)) {
                duplicatedSet.delete(id);
            }
        }
        onChange([...duplicatedSet]);
    };

    return (
        <Details label={i18n.general.filter} icon={IconEnum.FILTER}>
            <GridRow gutter={8}>
                {filtersData?.map((group) => {
                    return (
                        <GridCol col={3} key={group.id}>
                            <GridRow column gutter={4}>
                                <ToggleButton
                                    value={!!value?.includes(group.id)}
                                    onClick={(state) => {
                                        handleSelect(state, group.id);
                                    }}
                                    label={group.name}
                                />
                            </GridRow>
                        </GridCol>
                    );
                })}
            </GridRow>
        </Details>
    );
};

export default CategoryFilters;
